export const instaramLink = "https://www.instagram.com/artistreeio/";
export const twitterLink = "https://twitter.com/artistreeio";
export const tiktokLink = "https://vm.tiktok.com/ZTdDopTne/";
export const discordLink = "https://discord.gg/artistree";